<template>
  <div
    :class="[
      $style['cell'],
      { [$style[`cell--${size}`]]: !!size },
      { [$style[`cell--align-center`]]: !!alignCenter },
      { [$style[`cell--justify-center`]]: !!justifyCenter },
      { [$style[`cell--align-end`]]: !!alignEnd },
      { [$style[`cell--justify-end`]]: !!justifyEnd },
      { [$style[`cell--flex-row`]]: !!row },
      { [$style[`cell--tablet--${tablet}`]]: tablet },
      { [$style[`cell--desktop--${desktop}`]]: desktop },
      { [$style[`cell--start--${start}`]]: start },
      { [$style[`cell--desktop-row--${desktopRow}`]]: desktopRow }
    ]">
    <slot />
  </div>
</template>
<script setup lang="ts">
defineProps<{
  size?: string | Number | undefined
  tablet?: string | Number | undefined
  desktop?: string | Number | undefined
  start?: string | Number | undefined
  desktopRow?: string | Number | undefined
  alignCenter?: boolean |string | Number | undefined
  justifyCenter?: boolean | string | Number | undefined
  alignEnd?: boolean | boolean | string | Number | undefined
  justifyEnd?: boolean | string | Number | undefined
  row?: string | Number | undefined
}>()
</script>
<style lang="scss" module>
.cell {
  display: flex;
  flex-direction: column;
  width: 100%;

  &:empty {
    margin: -$spacing;
  }

  &--flex-row {
    flex-direction: row;
  }

  &--padding {
    padding: $spacing * 3 $spacing * 2;
  }

  &--align-center {
    display: inline-flex;
    align-items: center;
    text-align: center;
  }

  &--justify-center {
    justify-content: center;
  }

  &--hidden {
    &>* {
      display: none !important;
    }
  }

  &--align-end {
    align-items: flex-end;
  }

  &--justify-end {
    justify-content: flex-end;
  }

  @media (max-width: #{$breakpoint-mobile}) {
    &--hide-mobile {
      display: none;
    }
  }

  @media (max-width: #{$breakpoint-tablet}) {
    &--hide-tablet {
      display: none;
    }
  }
}

@for $i from 1 through 12 {
  .cell--start--#{$i} {
    grid-column-start: $i;

    @media (max-width: #{$breakpoint-mobile}) {
      grid-column-start: 1;
    }
  }
}

@for $i from 1 through 12 {
  .cell--desktop-row--#{$i} {
    @media (min-width: #{$breakpoint-mobile}) {
      grid-row: $i;
    }
  }
}

@for $i from 1 through 12 {
  .cell--#{$i} {
    grid-column-end: span $i;
  }
}

@media (min-width: #{$breakpoint-mobile}) {
  @for $i from 1 through 12 {
    .cell--tablet--#{$i} {
      grid-column-end: span $i;
    }
  }
}

@media (min-width: #{$breakpoint-tablet}) {
  @for $i from 1 through 12 {
    .cell--desktop--#{$i} {
      grid-column-end: span $i;
    }
  }
}
</style>
